import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
         light: true,
         themes: {
             light: {
                primary: '#002',
                secondary: '#ebeced',
                accent: '#23395d',
                error: '#f44336',
                warning: '#ffc107',
                info: '#cddc39',
                success: '#4caf50'
             },
             dark: {
                primary: '#4c586f',
                secondary: '#3e3e3b',
                accent: '#b29a86',
                error: '#f44336',
                warning: '#ffc107',
                info: '#cddc39',
                success: '#4caf50'
             }
         }
    },
});
